import { DataService } from './dataService'


export const DestinationCrossBorderService ={
    getDestinationCrossBorderList: async () => {
        return DataService.get('/admin/destination-border-charge/get_all')
    },
    editDestinationCrossBorder: async (data) => {
        return DataService.put('/admin/destination-border-charge/update', data)
    },
	addDestinationCrossBorder: async (data) => {
        return DataService.post('/admin/destination-border-charge/create', data)
    },
	deleteDestinationCrossBorder: async (data) => {
        return DataService.delete('/admin/destination-border-charge/delete', data)
    },    
}